import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const NAV_LINKS = [
  { label: "Início", to: "/" },
  { label: "Barbearia", to: "/barbearia" },
  { label: "Prótese Capilar", to: "/protese-capilar" },
  { label: "Clube", to: "/clube" },
  { label: "Resultados", to: "/resultados" },
  { label: "Unidades", to: "/unidades" },
  { label: "Depoimentos", to: "/depoimentos" },
  { label: "Dúvidas", to: "/duvidas" },
  { label: "Contato", to: "/contato" },
];

const DEFAULT_MESSAGES = {
  barbearia: "Olá, vim pelo site da Barbearia das Estrelas e gostaria de agendar um horário.",
  arapiraca: "Olá, vim pelo site e quero fazer uma avaliação de prótese capilar em Arapiraca.",
  garanhuns: "Oi, vim pelo site da Prime Capilar Clinic de Garanhuns. Quero fazer uma avaliação de prótese capilar.",
  maceio: "Olá, vim pelo site e quero fazer uma avaliação de prótese capilar na Arena Barbearia em Maceió.",
};

export function waLink(site, key = "barbearia", customMsg = null) {
  const digits = (site?.whatsapp || "5582991863607").replace(/\D/g, "");
  const msg = customMsg || site?.whatsapp_messages?.[key] || DEFAULT_MESSAGES[key] || DEFAULT_MESSAGES.barbearia;
  return `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`;
}

export function mapEmbed(query) {
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
}
